<div class="container border-top pt-5">
  <footer class="flex-wrap align-items-center">
    <article class="row">
      <a class="nav-link link-dark col-md d-flex align-items-start justify-content-center" href="https://discord.gg/GDdfq9AkfM">
        <img class="footer-icon float-start mx-2" src="/images/Discord-Logo-Black.svg" width="71" height="55" alt="" loading="lazy">
        <div>
          <h5 class="mb-0">Vassal on Discord</h5>
          <p>Chat with friends</p>
        </div>
      </a>

      <a class="nav-link link-dark col-md d-flex align-items-start justify-content-center" href="https://github.com/vassalengine/vassal">
        <img class="footer-icon float-start mx-2" src="/images/github-icon.svg" width="256" height="250" alt="" loading="lazy">
        <div>
          <h5 class="mb-0">Vassal on GitHub</h5>
          <p>We write code here</p>
        </div>
      </a>

      <a class="nav-link link-dark col-md d-flex align-items-start justify-content-center" href="/status.php">
        <img class="footer-icon float-start mx-2" src="/images/server-svgrepo-com.svg" width="512" height="512" alt="" loading="lazy">
        <div>
          <h5 class="mb-0">Server Status</h5>
          <p>Who's playing now?</p>
        </div>
      </a>
    </article>

    <div id="colophon" class="text-center pt-5">
      <div class="row text-muted">
        <p class="col mb-0">Library content is available under <a href="https://creativecommons.org/licenses/by-sa/4.0/">CC-BY-SA</a> unless otherwise noted. <svg class="svg-icon"><use xlink:href="#creative-commons"></use></svg><svg class="svg-icon"><use xlink:href="#creative-commons-by"></use></svg><svg class="svg-icon"><use xlink:href="#creative-commons-sa"></use></svg></p>
      </div>
      <div class="row text-muted">
        <p class="col">
          <a class="link-secondary text-decoration-none" href="/status.php">Status</a> | <a class="link-secondary text-decoration-none" href="/contact.html">Contact</a> | <a class="link-secondary text-decoration-none" href="/about.html#donate">Donate</a>
        </p>
      </div>
    </div>
  </footer>
</div>

<div class="svg-sprites">
  <div class="fontawesome">
    <svg xmlns="http://www.w3.org/2000/svg">
      <symbol id="creative-commons" viewBox="0 0 496 512">
        <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
        <path d="M245.8 214.9l-33.2 17.3c-9.4-19.6-25.2-19.9-27.5-19.9-22.1 0-33.2 14.6-33.2 43.8 0 23.6 9.2 43.8 33.2 43.8 14.5 0 24.7-7.1 30.6-21.3l30.6 15.5c-6.2 11.5-25.7 39-65.1 39-22.6 0-74-10.3-74-77.1 0-58.7 43-77.1 72.6-77.1 30.7 0 52.7 12 66 35.9zm143.1 0l-32.8 17.3c-9.5-19.8-25.7-19.9-27.9-19.9-22.1 0-33.2 14.6-33.2 43.8 0 23.6 9.2 43.8 33.2 43.8 14.5 0 24.7-7.1 30.5-21.3l31 15.5c-2.1 3.8-21.4 39-65.1 39-22.7 0-74-9.9-74-77.1 0-58.7 43-77.1 72.6-77.1 30.7 0 52.6 12 65.6 35.9zM247.6 8.1C104.7 8.1 0 123.1 0 256.1c0 138.5 113.6 248 247.6 248 129.9 0 248.4-100.9 248.4-248 0-137.9-106.6-248-248.4-248zm.9 450.8c-112.5 0-203.7-93-203.7-202.8 0-105.4 85.4-203.3 203.7-203.3 112.5 0 202.8 89.5 202.8 203.3 0 121.7-99.7 202.8-202.8 202.8z"/>
      </symbol>
    </svg>
    <svg xmlns="http://www.w3.org/2000/svg">
      <symbol id="creative-commons-by" viewBox="0 0 496 512">
        <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
        <path d="M314.9 194.4v101.4h-28.3v120.5h-77.1V295.9h-28.3V194.4c0-4.4 1.6-8.2 4.6-11.3 3.1-3.1 6.9-4.7 11.3-4.7H299c4.1 0 7.8 1.6 11.1 4.7 3.1 3.2 4.8 6.9 4.8 11.3zm-101.5-63.7c0-23.3 11.5-35 34.5-35s34.5 11.7 34.5 35c0 23-11.5 34.5-34.5 34.5s-34.5-11.5-34.5-34.5zM247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8 .1-113.8-90.2-203.3-202.8-203.3z"/>
      </symbol>
    </svg>
    <svg xmlns="http://www.w3.org/2000/svg">
      <symbol id="creative-commons-sa" viewBox="0 0 496 512">
        <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
        <path d="M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8 .1-113.8-90.2-203.3-202.8-203.3zM137.7 221c13-83.9 80.5-95.7 108.9-95.7 99.8 0 127.5 82.5 127.5 134.2 0 63.6-41 132.9-128.9 132.9-38.9 0-99.1-20-109.4-97h62.5c1.5 30.1 19.6 45.2 54.5 45.2 23.3 0 58-18.2 58-82.8 0-82.5-49.1-80.6-56.7-80.6-33.1 0-51.7 14.6-55.8 43.8h18.2l-49.2 49.2-49-49.2h19.4z"/>
      </symbol>
    </svg>
  </div>
</div>
